export const CUSTOMERS_API_ROUTES = {
  GET_CUSTOMERS: "/customers",
  GET_CUSTOMER_BY_ID: "/customers/profile/:id",
  CREATE_CUSTOMER: "/admin/user",
  UPDATE_CUSTOMER: "/customers/profile/:id",
  UPDATE_CUSTOMER_PASSWORD: "admin/update/:id",
  DELETE_CUSTOMER: "/admin/:id",
};
